"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OccupationFields = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _occupationConfig = require("./occupationConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var OccupationDefinition = _flowRuntime["default"].tdz(function () {
  return _occupationConfig.OccupationDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("isMilitary", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("occupation", _flowRuntime["default"].ref(OccupationDefinition)), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())))));

var OccupationFields = function OccupationFields(_arg) {
  var isMilitary = _arg.isMilitary,
      occupation = _arg.occupation,
      resetFields = _arg.resetFields;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
    key: _occupationConfig.jobTitle.key,
    textfield: _occupationConfig.jobTitle
  }), occupation.options && occupation.options.military && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Checkbox, {
    id: _occupationConfig.military.key,
    key: _occupationConfig.military.key,
    checkbox: _occupationConfig.military,
    onChange: function onChange() {
      return resetFields();
    }
  }), isMilitary && /*#__PURE__*/_react["default"].createElement(_fields.Textfield, {
    key: _occupationConfig.militaryNumber.key,
    textfield: _occupationConfig.militaryNumber
  })));
};

exports.OccupationFields = OccupationFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    isMilitary: selector(state, "".concat(componentKey, ".military"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var militaryNumberPath = "".concat(componentKey, ".militaryNumber");
  return {
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', militaryNumberPath, '')), dispatch((0, _reduxForm.untouch)('form', militaryNumberPath))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OccupationFields);

exports["default"] = _default;